import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'default'
})
export class DefaultPipe implements PipeTransform {

  transform(value: any, defaultVal: any): any {
     return (value) ? value : defaultVal;
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/pipes/default.pipe.ts